<template>
  <transaction-list
    :transactionService = transactionService
    :productService = productService
    :locationService = locationService
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Rental/Transactions/Overview'
  import transactionService from '@/services/licensor/transaction'
  import productService from '@/services/licensor/product'
  import locationService from '@/services/licensor/location'

  export default {
    components: {
      TransactionList
    },
    data () {
      return {
        transactionService: transactionService,
        productService: productService,
        locationService: locationService
      }
    },

    created () {
      this.$store.commit('UPDATE_TITLE', 'Transactions')
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Licensor/Transactions/Overview.vue